module.exports = __webpack_public_path__ + "img/aweber_logo@2x.ad9945c6.png";